import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoadingService } from '../../../../_services/LoadingService/loading.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-applicationloader',
  standalone: true,
  imports: [],
  templateUrl: './applicationloader.component.html',
  styleUrl: './applicationloader.component.scss'
})
export class ApplicationloaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  public show: boolean = true;
  public showLoader: boolean = false;
  constructor(private loadingService: LoadingService) {
    // setTimeout(() => {
    //   this.show = false;
    // }, 1500);
  }

  ngOnInit() {
    this.loadingService.showLoader$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((show) => {
      this.showLoader = show;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
